import { List as MantineList } from "@mantine/core";
import { componentWrapper, polymorphicComponentWrapper } from "../../utilities";
import styles from "./list.module.scss";
import type { IProps, IListItemProps, CustomListFactory, CustomListItemFactory } from "./list.types";

/**
 * List component for displaying ordered or unordered lists.
 * @returns {JSX.Element} The List component.
 */
const List = componentWrapper<CustomListFactory, IProps>("List", (props, ref) => {
    return (
        <MantineList
            ref={ref}
            data-variant={props.variant}
            classNames={{
                root: styles["root"],
                item: styles["item"],
                itemIcon: styles["itemIcon"],
                itemLabel: styles["itemLabel"],
                itemWrapper: styles["itemWrapper"],
            }}
            {...props}
        />
    );
});

/**
 * List item component for individual items within a list.
 * @returns {JSX.Element} The ListItem component.
 */
const ListItem = polymorphicComponentWrapper<CustomListItemFactory, IListItemProps>(
    "ListItem",
    ({ active, disabled, ...props }, ref) => {
        return (
            <MantineList.Item
                ref={ref}
                data-clickable={typeof props.onClick !== "undefined" || !!active}
                data-active={active}
                data-disabled={disabled || undefined}
                bdrs="lg"
                {...props}
            />
        );
    }
);

List.Item = ListItem;

export { List, ListItem };
